import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import MeuUsuarioService from "../../services/resource/meuUsuarioService";

const service = new MeuUsuarioService();

export function useAssinatura() {
    const [assinatura, setAssinatura] = useState(null);
    const [imagemUrl, setImagemUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [salvando, setSalvando] = useState(false);
    const [excluindo, setExcluindo] = useState(false);
    const urlAnteriorRef = useRef(null);

    const limparUrlAnterior = () => {
        if (urlAnteriorRef.current) {
            URL.revokeObjectURL(urlAnteriorRef.current);
            urlAnteriorRef.current = null;
        }
    };

    const carregar = useCallback(() => {
        setLoading(true);
        service.buscarAssinatura()
            .then(res => {
                setAssinatura(res.data);
                if (res.data?.existe) {
                    return service.baixarAssinaturaImagem();
                }
                return null;
            })
            .then(imgRes => {
                limparUrlAnterior();
                if (imgRes) {
                    const url = URL.createObjectURL(imgRes.data);
                    urlAnteriorRef.current = url;
                    setImagemUrl(url);
                } else {
                    setImagemUrl(null);
                }
            })
            .catch(error => {
                console.error("Erro ao carregar assinatura", error);
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        carregar();
        return limparUrlAnterior;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carregar]);

    function salvar(arquivo) {
        setSalvando(true);
        return service.salvarAssinatura(arquivo)
            .then(() => {
                toast.success("Assinatura salva com sucesso!");
                carregar();
            })
            .catch(error => {
                console.error("Erro ao salvar assinatura", error);
                throw error;
            })
            .finally(() => setSalvando(false));
    }

    function excluir() {
        setExcluindo(true);
        return service.excluirAssinatura()
            .then(() => {
                toast.success("Assinatura removida com sucesso!");
                carregar();
            })
            .catch(error => {
                console.error("Erro ao remover assinatura", error);
                throw error;
            })
            .finally(() => setExcluindo(false));
    }

    return {
        assinatura,
        imagemUrl,
        loading,
        salvando,
        excluindo,
        salvar,
        excluir,
    };
}
